// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useMutation } from '@tanstack/react-query';
import { useSubadminProfileApi } from '../../hooks/useSubadminProfileApi';


export const useSubAminEditProfile = () => {
//   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editSubadminProfile } = useSubadminProfileApi();

  return useMutation({
    mutationKey: ['EditsubadminProfile'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editSubadminProfile(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'subadmin Profile Updated successfully',
        'success'
      );
    //   queryClient.invalidateQueries({
    //     queryKey: ['getChoiceGroup'],
    //     exact: false,
    //   });
    },
    onError: (error: any) => {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      showMessage(apiMessage || 'Failed to update', 'error');
    },
  });
};
